import { GenericMapOptions } from 'helpers/dropdown-options';

export const paymentMethodsOptions: GenericMapOptions = {
  fields: { label: 'methodName', value: 'id' },
};
